import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    // Ne lock le scroll que si la modale est visible au mount (pas hidden)
    if (!this.element.classList.contains("hidden")) {
      document.body.classList.add("overflow-hidden")
    }
    this._boundSubmitGuard = this.submitGuard.bind(this)
    this.element.addEventListener("submit", this._boundSubmitGuard, true)

    // Observe les changements de classe pour sync overflow-hidden quand la
    // modale est affichée/cachée dynamiquement (toggle via onclick externe).
    this._observer = new MutationObserver(() => {
      const hidden = this.element.classList.contains("hidden")
      if (hidden) {
        document.body.classList.remove("overflow-hidden")
      } else {
        document.body.classList.add("overflow-hidden")
      }
    })
    this._observer.observe(this.element, { attributes: true, attributeFilter: [ "class" ] })
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    this.element.removeEventListener("submit", this._boundSubmitGuard, true)
    this._observer?.disconnect()
  }

  submitGuard(event) {
    const submitter = event.submitter
    if (submitter && submitter.type === "submit") return
    event.preventDefault()
    event.stopPropagation()
  }

  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }

  closeOnEscape(event) {
    const tag = event.target.tagName
    if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") {
      event.target.blur()
      return
    }
    this.close()
  }

  close() {
    const active = document.activeElement
    if (active && (active.tagName === "INPUT" || active.tagName === "SELECT" || active.tagName === "TEXTAREA")) {
      return
    }

    if (this.hasDialogTarget) {
      this.dialogTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    } else {
      const turboFrame = this.element.closest("turbo-frame")
      const isStandalone = this.element.id && !turboFrame
      if (isStandalone) {
        // Modal réutilisable (ex: trouver des leads) — juste cacher, pas retirer
        this.element.classList.add("hidden")
      } else if (turboFrame) {
        turboFrame.innerHTML = ""
      } else {
        this.element.remove()
      }
      document.body.classList.remove("overflow-hidden")
    }
  }

  preventEnterSubmit(event) {
    const tag = event.target.tagName
    const type = event.target.type
    if (tag === "INPUT" && type !== "submit" && type !== "button") {
      event.preventDefault()
    }
  }

  closeOnOverlay(event) {
    const content = this.element.querySelector(".modal-content")
    if (content && content.contains(event.target)) return
    this.close()
  }
}
